import { isValidHour, isValidMinute } from "./date.js";
import dayjs from "dayjs";
import { RRule, rrulestr, Weekday } from "../rrule/index.js";
const convertRruleByWeekdayToDayOfWeek = (byWeekday) => {
    let dayOfWeek = null;
    let dayOfWeekIso = null;
    let parsed;
    if (typeof byWeekday === 'number') {
        parsed = new Weekday(byWeekday);
    }
    else if (typeof byWeekday === 'string') {
        parsed = Weekday.fromStr(byWeekday);
    }
    else {
        parsed = byWeekday;
    }
    if (!parsed) {
        return { dayOfWeek, dayOfWeekIso };
    }
    dayOfWeek = parsed.getJsWeekday();
    dayOfWeekIso = dayOfWeek === 0 ? 7 : dayOfWeek;
    return { dayOfWeek, dayOfWeekIso };
};
const getOpeningHoursFromLegacySchedule = ({ workStartHours, workStartMinutes, workEndHours, workEndMinutes, lunchStartHours, lunchStartMinutes, lunchEndHours, lunchEndMinutes, rrule, }) => {
    const openingHours = [];
    if (!rrule) {
        return openingHours;
    }
    const currentRrule = typeof rrule === "string" ? rrulestr(rrule) : new RRule(rrule.origOptions);
    // get the week days
    const { byweekday } = currentRrule.origOptions;
    if (!byweekday) {
        return openingHours;
    }
    const daysArray = Array.isArray(byweekday) ? [...byweekday] : [byweekday];
    // for each day, we try to determine the opening and closing times
    daysArray.forEach((day) => {
        const { dayOfWeek, dayOfWeekIso } = convertRruleByWeekdayToDayOfWeek(day);
        if (dayOfWeek === null || dayOfWeekIso === null) {
            return;
        }
        if (isValidHour(workStartHours) &&
            isValidMinute(workStartMinutes) &&
            isValidHour(workEndHours) &&
            isValidMinute(workEndMinutes)) {
            // set work start and end
            const workStart = dayjs()
                .startOf("day")
                .hour(workStartHours)
                .minute(workStartMinutes);
            const workEnd = dayjs()
                .startOf("day")
                .hour(workEndHours)
                .minute(workEndMinutes);
            // check for lunch
            if (isValidHour(lunchStartHours) &&
                isValidMinute(lunchStartMinutes) &&
                isValidHour(lunchEndHours) &&
                isValidMinute(lunchEndMinutes)) {
                // set lunch start and end
                const lunchStart = dayjs()
                    .startOf("day")
                    .hour(lunchStartHours)
                    .minute(lunchStartMinutes);
                const lunchEnd = dayjs()
                    .startOf("day")
                    .hour(lunchEndHours)
                    .minute(lunchEndMinutes);
                if (lunchStart.isAfter(workStart) &&
                    lunchStart.isBefore(workEnd) &&
                    lunchEnd.isAfter(lunchStart) &&
                    lunchEnd.isBefore(workEnd)) {
                    // create two time ranges with a gap for lunch break
                    openingHours.push({
                        dayOfWeek,
                        dayOfWeekIso,
                        opens: workStart.format("HH:mm"),
                        closes: lunchStart.format("HH:mm"),
                    });
                    openingHours.push({
                        dayOfWeek,
                        dayOfWeekIso,
                        opens: lunchEnd.format("HH:mm"),
                        closes: workEnd.format("HH:mm"),
                    });
                }
            }
            else {
                // create one time range
                openingHours.push({
                    dayOfWeek,
                    dayOfWeekIso,
                    opens: workStart.format("HH:mm"),
                    closes: workEnd.format("HH:mm"),
                });
            }
        }
    });
    return openingHours;
};
const convertDayToRruleWeekDay = (day) => {
    try {
        if (Number(day) === 1) {
            return RRule.MO;
        }
        if (Number(day) === 2) {
            return RRule.TU;
        }
        if (Number(day) === 3) {
            return RRule.WE;
        }
        if (Number(day) === 4) {
            return RRule.TH;
        }
        if (Number(day) === 5) {
            return RRule.FR;
        }
        if (Number(day) === 6) {
            return RRule.SA;
        }
        // handle both dayjs day and ISO day
        if (Number(day) === 7 || Number(day) === 0) {
            return RRule.SU;
        }
    }
    catch (error) {
        return null;
    }
};
export { convertRruleByWeekdayToDayOfWeek, getOpeningHoursFromLegacySchedule, convertDayToRruleWeekDay, };
//# sourceMappingURL=schedule.js.map